import { StyledLoading } from "./style";
import loadingData from "./loading-animation.json";
import useLoadingStore from "store/useLoadingStore";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";

function Loading() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const {
    completeLoadingState,
    loadingMessage,
    loadingParentRef,
    setCompleteLoadingState,
  } = useLoadingStore();
  const [animationBar1, setAnimationBar1] = useState(false);
  const [animationBar2, setAnimationBar2] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [parentElementRect, setParentElementRect] = useState<
    DOMRect | undefined
  >(loadingParentRef?.current?.getBoundingClientRect());
  useEffect(() => {
    if (completeLoadingState) {
      const timeout1 = setTimeout(() => setAnimationBar1(true), 100);
      const timeout2 = setTimeout(() => setAnimationBar2(true), 300);
      const timeout3 = setTimeout(() => setFadeOut(true), 1000);
      const timeout4 = setTimeout(() => setCompleteLoadingState(false), 1200);

      return () => {
        clearTimeout(timeout1);
        clearTimeout(timeout2);
        clearTimeout(timeout3);
        clearTimeout(timeout4);
      };
    }
  }, [completeLoadingState]);

  useEffect(() => {
    const element = loadingParentRef?.current;
    if (!element) return;

    // 요소 크기 변화를 감지
    const resizeObserver = new ResizeObserver(() => {
      setParentElementRect(element.getBoundingClientRect());
    });
    // 속성 변화를 감지 (예: 스타일 변경)
    const mutationObserver = new MutationObserver(() => {
      setParentElementRect(element.getBoundingClientRect());
    });
    // 요소에 observer 연결
    resizeObserver.observe(element);
    mutationObserver.observe(element, { attributes: true });
    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [loadingParentRef?.current]);

  return (
    <StyledLoading
      className={`loading-container ${fadeOut && "fade-out"}`}
      style={
        parentElementRect && {
          top: `${parentElementRect.top}px`,
          left: `${parentElementRect.left}px`,
          width: `${parentElementRect.width}px`,
          height: `${parentElementRect.height}px`,
        }
      }
    >
      <div className="loading-box">
        <span className="lottie-wrap">
          {completeLoadingState ? (
            <div className="success">
              <span className="circle" />
              <div className="wrap">
                <span className="bar bar1">
                  <span className={`inner-bar ${animationBar1 && "active"}`} />
                </span>
                <span className="bar bar2">
                  <span className={`inner-bar ${animationBar2 && "active"}`} />
                </span>
              </div>
            </div>
          ) : (
            <Lottie
              options={defaultOptions}
              height={80}
              width={200}
              isClickToPauseDisabled={true}
            />
          )}
        </span>
        {loadingMessage && (
          <p className="message">
            {loadingMessage.split("\n").map((message, idx) => (
              <React.Fragment key={idx}>
                {idx !== 0 && <br />}
                {message}
              </React.Fragment>
            ))}
          </p>
        )}
      </div>
    </StyledLoading>
  );
}

export default Loading;
